import React, {useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import Box from "@mui/material/Box";
import ModalAddEdges from "./ModalAddEdges";
import CellShortenedName from "../../orders/organization/estimate/CellShortenedName";
import {gluing} from "../../../../../data/Gluing";
import ModalAlert from "../ModalAlert";
import ButtonCreate, {buttonCreateAutoSizeSx, customerPageHeaderRowSx} from "../../../button/ButtonCreate";
import MenuItem from "@mui/material/MenuItem";
import OrderEdgeController from "../../../../../API/details/customer/OrderEdgeController";
import {Typography} from "@mui/material";
import OrderEdgeControllerOrganization from "../../../../../API/details/organization/OrderEdgeControllerOrganization";
import {replaceEmptyStringsOnNull} from "../../../../../utils/ReplaceEmptyStringsOnNull";

const CustomerEdgesTable = ({
                                data,
                                samples,
                                isError,
                                setData,
                                enableEditing,
                                enableRowSelection,
                                orderId,
                                settings,
                                handleModalAlert,
                                organization,
                                reserve,
                                model,
                                composition
                            }) => {
    const rowInitValue = {
        material: {},
        edgeType: Object.entries(gluing)[0][0],
        note: ""
    }

    const [addEdgeModalOpen, setAddEdgeModalOpen] = useState(false);
    const [alertData, setAlertData] = useState({});

    const [rowSelection, setRowSelection] = useState({});
    const [currentEditRowData, setCurrentEditRowData] = useState(rowInitValue);
    const [currentEditRowId, setCurrentEditRowId] = useState(null);
    const [isNew, setIsNew] = useState(true);
    const [replace, setReplace] = useState(false)
    const [loading, setLoading] = useState(false)

    const handleCloseAlert = () => {
        setAlertData((alert) => {
            return {...alert, open: false}
        })
    }

    const handleClose = () => {
        setAddEdgeModalOpen(false)
        setCurrentEditRowData(rowInitValue)
        setIsNew(true)
        setReplace(false)
    }

    const handleUpdate = (data, reset) => {
        setLoading(true)
        const api = model ? OrderEdgeControllerOrganization.editModel(currentEditRowId, replaceEmptyStringsOnNull(data)) :
            composition ? OrderEdgeControllerOrganization.editComposition(currentEditRowId, replaceEmptyStringsOnNull(data)) :
                organization ?
                    (reserve ? OrderEdgeControllerOrganization.editReserve(currentEditRowId, replaceEmptyStringsOnNull(data))
                        : OrderEdgeControllerOrganization.edit(currentEditRowId, replaceEmptyStringsOnNull({
                            "materialEstimateUnitId": data.materialId,
                            "materialId": data.materialId,
                            "materialName": data.materialName,
                            "shortName": data.shortName,
                            "materialArticleNumber": data.materialArticleNumber,
                            "edgeType": data.edgeType,
                            "note": data.note
                        }))) :
                    OrderEdgeController.edit(orderId, currentEditRowId, replaceEmptyStringsOnNull(data))
        api.then(function (response) {
            setData(prev => prev.map(el => el.id === response.data.id ? response.data : el))
            handleModalAlert("Данные изменены", 'success')
            reset()
        })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .finally(() => setLoading(false))
    }
    const handleReplace = (value, reset) => {
        setLoading(true)
        OrderEdgeControllerOrganization.replace(currentEditRowId, value.materialId).then(function (response) {
            const newData = data.map(el => response.data.find(item => item.id === el.id) || el)
            setData(newData)
            handleModalAlert("Данные изменены", 'success')
            reset()
        })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .finally(() => setLoading(false))
    }

    const handleDeleteDetail = (row) => {
        const api = organization ? OrderEdgeControllerOrganization : OrderEdgeController
        api.delete(row.id).then(function () {
            setData(prev => prev.filter(el => el.id !== row.id))
            handleModalAlert("Данные удалены", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error)
            })
    };

    const handleSubmit = (data, reset) => {
        setLoading(true)
        const api = model ? OrderEdgeControllerOrganization.saveModel(replaceEmptyStringsOnNull(data)) :
            composition ? OrderEdgeControllerOrganization.saveComposition(replaceEmptyStringsOnNull(data)) :
                organization ?
                    (reserve ? OrderEdgeControllerOrganization.saveReserve(replaceEmptyStringsOnNull(data))
                        : OrderEdgeControllerOrganization.save(replaceEmptyStringsOnNull({
                            "materialEstimateUnitId": data.materialId,
                            "edgeType": data.edgeType,
                            "note": data.note
                        }), orderId))
                    : OrderEdgeController.save(orderId, replaceEmptyStringsOnNull(data))
        api.then(function (response) {
            setData(prev => [...prev, response.data])
            handleModalAlert("Данные добавлены", 'success')
            reset()
        })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .finally(() => setLoading(false))
    }

    const handleAddEdge = () => {
        setAddEdgeModalOpen(true)
    };

    const handleEditEdge = (row) => {
        const value = {
            material: {
                articleNumber: row.materialArticleNumber,
                id: row.materialId,
                name: row.materialName,
                shortName: row.shortName
            },
            edgeType: row.edgeType,
            note: row.note
        }
        setCurrentEditRowData(value)
        setAddEdgeModalOpen(true)
        setCurrentEditRowId(row.id);
        setIsNew(false);
    };
    const customerReplaceRequestsCutting = (row) => {
        setCurrentEditRowData({
            material: {
                articleNumber: row.materialArticleNumber,
                id: row.materialId,
                name: row.materialName
            },
            edgeType: row.edgeType
        })
        setCurrentEditRowId(row.id);
        setAddEdgeModalOpen(true)
        setReplace(true)
    };

    const columns = useMemo(() => {
        const baseColumns = [
            {
                header: 'Наименование', accessorKey: 'materialName', minSize: 800,
                Cell: ({cell, row}) => {
                    return (
                        <span
                            style={{
                                color: row.original.placeholder ? 'red' : 'black'
                            }}>
                               {cell.getValue()}
                            </span>
                    );
                }
            },
            {
                header: 'Тип поклейки', accessorKey: 'edgeType', size: 250,
                Cell: ({cell}) => gluing[cell.getValue()],
            },
            {
                id: 'note',
                header: 'Комментарий',
                accessorKey: 'note',
                minSize: 250
            },
        ]
        if (!model && !composition) {
            baseColumns.splice(0, 0, {
                header: 'Артикул',
                accessorKey: 'materialArticleNumber',
                size: 250,
                Cell: ({cell, row}) => {
                    return (
                        <span
                            style={{
                                color: row.original.placeholder ? 'red' : 'black'
                            }}>
                              <CellShortenedName
                                  value={cell.getValue()}
                                  numberOfCharacters={15}
                              />
                            </span>
                    );
                }
            });
        }

        return baseColumns;

    }, [data, model, composition]);

    const menuItem = !reserve && organization ? [
        {type: "edit", text: "Редактировать", handler: handleEditEdge},
        {type: "delete", text: "Удалить", handler: handleDeleteDetail},
        {type: "replace", text: "Заменить кромку", handler: customerReplaceRequestsCutting}
    ] : [
        {type: "edit", text: "Редактировать", handler: handleEditEdge},
        {type: "delete", text: "Удалить", handler: handleDeleteDetail}
    ]

    return (<Box
        sx={{
            overflow: 'auto',
            maxWidth: settings ? 'calc(100vw - 410px)' : "1700px",
        }}
    >
        <Box sx={customerPageHeaderRowSx}>
            <Typography sx={{fontSize: "24px", fontWeight: 700}}>Кромки</Typography>
            <ButtonCreate
                text={!orderId ? "Добавить кромку" : samples ? "Добавить кромку в шаблон" : "Добавить кромку в заказ"}
                width={samples || !orderId ? "auto" : 255}
                height={samples || !orderId ? "auto" : 38}
                sx={samples || !orderId ? buttonCreateAutoSizeSx : undefined}
                onClick={handleAddEdge}
            />
        </Box>
        <MaterialReactTable
            renderTopToolbar={({table}) => {
                return <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "7px",
                    backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                }}>
                    <MRT_ToolbarAlertBanner table={table}/>
                    <Box sx={{display: "flex"}}>
                        <MRT_ToggleFiltersButton table={table}/>
                        <MRT_GlobalFilterTextField table={table}/>
                    </Box>
                </Box>
            }}
            selectAllMode={"all"}
            muiTableContainerProps={{
                sx: {
                    maxHeight: `calc(100vh - 420px)`,
                    maxWidth: settings ? 'calc(100vw - 410px)' : "1700px",
                }
            }}
            muiTableBodyCellProps={{
                sx: {
                    p: '0px 0px 0px 10px',
                    m: '0px 0px 0px 0px',
                    border: "none",
                    "&:after": {
                        display: "none",
                    },
                    "& td:after": {
                        "&:hover": {
                            backgroundColor: "red"
                        }
                    },
                    "&:not(:last-of-type)": {
                        borderRight: '1px solid #EAEBEA',

                    },
                    "&:first-of-type": {
                        padding: 0,
                        width: "50px",
                        height: "36px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: (theme) => theme.palette.text.light,
                        "& .MuiButtonBase-root": {
                            borderRadius: "4px",
                            width: "24px",
                            height: "24px",
                            opacity: 1,
                            margin: 0,
                            padding: 0,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            }
                        }
                    },
                    "& li": {
                        listStyleType: "none",
                        "& a": {
                            color: "#006CCC",
                            textDecoration: "none",
                            "&:hover": {
                                textDecoration: "underline"
                            }
                        }
                    }
                },
            }}
            muiTableHeadCellProps={{
                sx: {
                    border: '1px solid #EAEBEA',
                    backgroundColor: "#F5F6FA",
                    padding: "10px",
                    paddingBottom: " 0.2rem",
                    paddingTop: "0.2rem"
                },
            }}
            muiTableBodyRowProps={({row}) => {
                return ({
                    sx: () => ({
                        height: '36px',
                        backgroundColor: "white",
                        "&:hover& td:after": {
                            display: "none",
                        },
                        "&.MuiTableRow-root.Mui-selected": {
                            backgroundColor: (theme) => theme.palette.primary.light70,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.light50,
                            },
                        },
                        "&:hover": {
                            "& td:after": {
                                display: "none",
                            },
                            backgroundColor: (theme) => theme.palette.primary.stroke,
                        },
                        '&:nth-of-type(even)': {
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                            backgroundColor: (theme) => theme.palette.primary.lightGrey,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            },
                        },
                    })
                })
            }}

            displayColumnDefOptions={{
                'mrt-row-actions': {
                    header: "",
                    size: 3,
                    minSize: 3,
                    grow: false,
                },
            }}
            muiSearchTextFieldProps={{
                placeholder: `Поиск`,
                sx: {
                    paddingTop: "5px",
                    paddingBottom: "0px",
                    "& .MuiCollapse-root": {
                        borderRadius: '12px',
                        height: 40, width: 290,
                        "& .MuiSvgIcon-root": {
                            color: "#737478"
                        },
                        '& .MuiOutlinedInput-input': {
                            padding: 0
                        }
                    }
                },
                variant: 'outlined',
            }}
            columns={columns}
            data={isError ? [] : data}
            rowHeight={13}
            columnSpacing={1}
            onRowSelectionChange={setRowSelection}
            state={{rowSelection, showGlobalFilter: true}}
            initialState={{
                columnVisibility: {
                    id: false,
                },
            }}
            enableRowSelection={enableRowSelection}
            getRowId={(originalRow) => originalRow.id}
            selectionPadding={1}
            selectionCss={{
                backgroundColor: 'lightblue',
                borderWidth: '2px',
                borderStyle: 'solid',
                borderColor: 'blue',
                borderRadius: '4px',
            }}
            renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                return <MenuItem
                    key={el.type}
                    disabled={el.type === "edit" && organization && !reserve && row.original.placeholder}
                    onClick={() => {
                        el.handler(row.original)
                        closeMenu();
                    }}
                    sx={{
                        margin: "0 8px",
                        borderRadius: "4px",
                        "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                    }}
                >
                    {el.text}
                </MenuItem>
            })
            }
            localization={MRT_Localization_RU}
            enableRowActions={true}
            enableToolbarInternalActions={false}

        />
        <ModalAddEdges
            title={replace ? "Заменить кромку" : isNew ? "Добавить кромку" : "Изменить кромку"}
            replace={replace}
            byMaterialEstimateUnit={!reserve && organization}
            initValue={currentEditRowData}
            open={addEdgeModalOpen}
            onClose={handleClose}
            handleSubmit={replace ? handleReplace : isNew ? handleSubmit : handleUpdate}
            handleModalAlert={handleModalAlert}
            orderId={orderId}
            loading={loading}
            modelOrComposition={model || composition}
        />
        <ModalAlert data={alertData} onClose={handleCloseAlert}/>
    </Box>);
};

export default CustomerEdgesTable;
